// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__7BscQ","rootCenter":"LoadMoreObserver_rootCenter__3cTVr","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1HWYY"};